import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "./Siteconfig";
import RichText from "./RichText";
import { publicApi } from "../admin/adminApi";
import useScrollReveal from "../hooks/useScrollReveal";
import "./Faq.css";
const FALLBACK_FAQS = FAQS.map((item, i) => ({
  _id: `static-${i}`,
  question: item.q,
  answer: item.a,
}));
export default function FAQ() {
  const revealRef = useScrollReveal();
  const [faqs, setFaqs] = useState(FALLBACK_FAQS);
  const [openIndex, setOpenIndex] = useState(0);
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await publicApi.listFaqs();
        if (!cancelled && Array.isArray(data) && data.length > 0) setFaqs(data);
      } catch {
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);
  const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));
  return (
    <section className="faq" id="faq" ref={revealRef}>
      <div className="container">
        <div className="section-head center reveal">
          <span className="eyebrow">FAQ</span>
          <h2>Frequently Asked Questions</h2>
        </div>
        <div className="faq__list">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div key={item._id || i} className={`faq__item${open ? " faq__item--open" : ""}`}>
                <button
                  type="button"
                  className="faq__question"
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span>{item.question}</span>
                  <ChevronDown size={18} className="faq__chevron" />
                </button>
                {open && (
                  <RichText
                    as="div"
                    profile="basic"
                    html={item.answer}
                    id={`faq-answer-${i}`}
                    className="faq__answer"
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}